<template>
	<div id="app">
		<transition name="fade" mode="out-in">
			<router-view/>
		</transition>
		<!-- <DatePicker type="date" :placeholder="$t('test')" style="width: 200px"></DatePicker>
		<span @click="changeLang">切换语言</span> -->
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import { setup } from '@/langs'
	// import '../src/plugins/jquery-3.6.0.min.js'
	export default {
		name: 'test',
		data() {
			return {
				
			}
		},
		computed: {
			...mapState(['lang'])
		},
		created (){
			this.sendLanguage()
			// console.log(this.lang)
		},
		methods: {
			changeLang(){
				setup(this.lang == 'zh' ? 'en' : 'zh')
				// console.log(this.lang)
			},
			sendLanguage(){
				this.$axios.get('/api/Public/SetLanguage?culture='+this.lang)
				.then(async (res) => {
					// console.log(res)
					// if(res.status == 1){
					// 	console.log(8888)
					// }else{
					// 	// this.$Message.error(res.data.msg)
					// }
				})
				.catch((err) => {
					console.log(err)
				})
				console.log(localStorage.getItem('localeLanguage'))
			}
		}
	}
</script>
<style lang="less">
html {
  height: 100%;
}

body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-size:14px;
  font-family: "Microsoft YaHei","微软雅黑","Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",Arial,sans-serif;
overflow: auto!important;
padding-right: 0!important;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
    padding: 0;
  }
}
#app{
	height: 100%;
	position: relative;
}
ul,li,dl,ol{
	list-style-type: none;
}
</style>
